<template>
    <div>
        <el-menu default-active="1" class="el-menu-group" mode="horizontal" @select="handleSelect" >
            <el-menu-item index="1">待处理工单</el-menu-item>
            <el-menu-item index="2">待审批工单</el-menu-item>
            <el-menu-item index="3"> &nbsp;全部工单</el-menu-item>
        </el-menu>
        <div style='margin-top:20px'></div>
        <div class="line"></div>
        <v-content1 v-if="itemVal==1"></v-content1>
        <v-content2 v-if="itemVal==2"></v-content2>
        <v-content3 v-if="itemVal==3"></v-content3>
    </div>
</template>

<script>
import vContent1 from './WOManageHandle.vue';
import vContent2 from './WOManageReply.vue';
import vContent3 from './WOManageEnd.vue';
import Bus from '../../components/common/bus';
export default {
    data() {
        return {
            itemVal:'1',
        }
    },
    components: {
        vContent1,
        vContent2,
        vContent3,
    },
    mounted() {
    },
    methods: {
        refresh(){
            history.go(0);
        },
        handleSelect(key, keyPath) {
            this.itemVal = key;
        },
    }
}
</script>
<style scoped>


</style>
